<template>
    <v-container>
        <!-- 給与控除情報画面 -->
        <v-form>
            <v-card class="headTitle" flat>
                <v-row>
                    <v-col cols="3" class="headSearch">
                        <ryou-select class="bukens" :items="dynamicItems" :itemText="'build_group_name'"
                            :label="'物件グループ名'" :itemValue="'build_group_id'" v-model="select" :value="select">
                        </ryou-select>
                    </v-col>
                    <v-col cols="1" class="monthCol">
                        <div class="monthLab">請求月</div>
                    </v-col>
                    <v-col cols='3' class="dateSearch">
                        <ryou-date-format ref="dateFormatInput" v-model="queryDate" :value="queryDate"
                            :loadFlag="loadFlag" @ReClaimInfoGet="ReClaimInfoGet"></ryou-date-format>
                    </v-col>
                </v-row>
                <v-row>
                    <v-card-title class="showTime">
                        {{this.viewDate}}
                    </v-card-title>
                </v-row>
                <v-form ref="tableForm" v-model="tableForm" lazy-validation>
                    <ryou-table ref="ryouTable" :rowKey="rowKeyEdit" :title="'表示一覧'" :headers="headers"
                        :queryParams="queryParam" :height="height" :url="url" :showSelect="showSelect"
                        :singleSelect="singleSelect" :needSearch="true">
                    </ryou-table>
                </v-form>
                <v-card-actions>
                    <ryou-black-btn :label="'ファイル出力'" :handlerClick="downloadCSV" :iconCls="'mdi-file-download'">
                    </ryou-black-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
    import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
    import RyouSelect from "@/components/formInput/RyouSelect.vue";
    import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
    import RyouTable from "@/components/table/RyouTable.vue";
    import { RyouTableMixins } from "@/mixins/RyouTableMixins";
    import fileDownload from "js-file-download";

    export default {
        name: "SalaryDeductionInformation",
        mixins: [RyouTableMixins],
        components: {
            RyouDateFormat,
            RyouSelect,
            RyouBlackBtn,
            RyouTable
        },
        mounted() {
        },
        data() {
            return {
                viewDate: "",//左上に年月を表示
                queryDate: new Date().toISOString().substr(0, 7),//検索用年月日
                loadFlag: false,
                height: 545,
                showSelect: true,
                singleSelect: false,
                selected: [],//チェックボックス選択の項目データ
                tableForm: true,
                select: "",//コンボボックスの選択値
                dynamicItems: [],//コンボボックスのすべてのデータ
                rowKeyEdit: "rowIndex",
                tableName: "ryouTable",
                headers: [
                    {
                        text: "物件名",
                        class: "blue lighten-2 title",
                        value: "building_name",
                        align: "center",
                        width: "120px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "部屋番号",
                        class: "blue lighten-2 title",
                        value: "room_id",
                        align: "center",
                        width: "135px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "入居区分",
                        class: "blue lighten-2 title",
                        value: "dormitory_student_name",
                        align: "center",
                        width: "135px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "社員番号",
                        class: "blue lighten-2 title",
                        value: "user_id",
                        align: "center",
                        width: "135px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "氏名",
                        class: "blue lighten-2 title",
                        value: "user_name",
                        align: "center",
                        width: "150px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "部署",
                        class: "blue lighten-2 title",
                        value: "affiliation",
                        align: "center",
                        width: "120px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "入居開始日",
                        class: "blue lighten-2 title",
                        value: "in_dormitory_date",
                        align: "center",
                        width: "165px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "退去予定日",
                        class: "blue lighten-2 title",
                        value: "out_dormitory_date",
                        align: "center",
                        width: "165px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "部屋代",
                        class: "blue lighten-2 title",
                        value: "room_fee",
                        type: "number",
                        align: "center",
                        width: "130px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "食事代",
                        class: "blue lighten-2 title",
                        value: "meal_amount",
                        type: "number",
                        align: "center",
                        width: "130px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "電気代",
                        class: "blue lighten-2 title",
                        value: "electrical_use_fee",
                        type: "number",
                        align: "center",
                        width: "130px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "ガス代",
                        class: "blue lighten-2 title",
                        value: "gas_use_fee",
                        type: "number",
                        align: "center",
                        width: "130px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "水道代",
                        class: "blue lighten-2 title",
                        value: "water_use_fee",
                        type: "number",
                        align: "center",
                        width: "130px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "自治会費",
                        class: "blue lighten-2 title",
                        value: "resident_association_cost",
                        type: "number",
                        align: "center",
                        width: "135px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "合計",
                        class: "blue lighten-2 title",
                        type: "number",
                        value: "total_fee",
                        align: "center",
                        width: "130px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "",
                        value: "build_group_id",
                        width: "1px",
                        type: "hidden",
                        sortable: false,
                        groupable: false,
                        filter: this.bgFilter
                    }
                ],
                url: {
                    list: "/salaryDeductionInformation/claimInfoGet"
                }
            }
        },
        methods: {
            viewTimeYM(value) {
                //フォーマットの年月を返し
                return value.substr(0, 4) + "年" + value.substr(5, 2) + "月";
            },
            viewTimeYMD(value) {
                //フォーマットの年月日を返し
                return value.substr(0, 4) + "年" + value.substr(5, 2) + "月" + value.substr(5, 2) + "月" + value.substr(8, 2) + "日";
            },
            initViewParams() {
                //ビュー検索用URLパラメータ
                let params =
                    "/" + this.queryDate.substr(0, 7)
                    + "/" + this.$store.getters.getUserId
                    + "/" + this.$store.getters.getUserClass

                return params;
            },
            initData() {
                //物件グループ検索用URLパラメータ
                let params = {
                    userId: this.$store.getters.getUserId,
                    userClass: this.$store.getters.getUserClass,
                }
                //物件グループ取得
                this.getRequest("/masterMeal/propertyGroupGet", params, this.$store.getters.getUserToken).then(data => {
                    if (data.success) {
                        //物件グループ取得、コンボボックスのすべてのデータ値を賦与
                        this.dynamicItems = data.result;
                        //空要素の追加
                        this.dynamicItems.push(this.select);
                    }
                });
            },
            bgFilter(value) {
                //チェックボックス選択の項目データをクリア
                this.$refs.ryouTable.selected = [];

                //物件グループフィルタ
                if (!this.select) {
                    return true;
                }
                return value.toLowerCase().includes(this.select.toLowerCase());
            },
            downloadCSV() {
                //チェックボックス選択の項目データ取得
                this.selected = this.selectionRows;

                //CSV作成
                this.postRequest("/salaryDeductionInformation/claimInfoCSVCreate", this.selected, this.$store.getters.getUserToken).then((resp) => {
                    //ファイルパスは戻り
                    if (resp.success) {
                        let streamParams = {
                            filePath: resp.result,
                        };

                        //CSVはダウンロード
                        this.getStreamRequest('/salaryDeductionInformation/claimInfoCSVGet', streamParams, this.$store.getters.getUserToken).then(res => {
                            const blob = new Blob([res], { type: 'application/octet-stream;charset=utf-8' });
                            return fileDownload(blob, "給与控除情報一覧_" + this.getDateTime() + ".csv");
                        }).catch(function (error) {
                            console.log(error);
                        });
                    }
                });
            },
            getDateTime() {
                const year = new Date().getFullYear()
                const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1)
                const date = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
                const hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
                const mm = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
                const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
                const nowTime = year + month + date + hh + mm + ss
                return nowTime
            },
            ReClaimInfoGet() {

                //チェックボックス選択の項目データをクリア
                this.$refs.ryouTable.selected = [];
                //ビューデータ再検索
                this.url.list = "/salaryDeductionInformation/claimInfoGet" + this.initViewParams();
                //データ再取得
                this.$refs.ryouTable.loadData();

                setTimeout(() => {
                }, 100);
            }
        },
        created() {

            var _that = this;

            this.url.list = _that.url.list + this.initViewParams();

            this.viewDate = this.viewTimeYM(_that.queryDate);

            this.initData();
        },
        watch: {
            queryDate(value) {

                this.viewDate = this.viewTimeYM(value);
            },
            viewDate() {

                this.$refs.dateFormatInput.viewDateFlagChange(true);
            },
        },
    };
</script>

<style>
    .headTitle {
        padding: 20px;
        height: 200px;
    }

    .dateSearch {
        padding-left: 0;
        padding-bottom: 0px;
    }

    .headSearch {
        padding-bottom: 0px;
        margin-left: 50px;
    }

    .showTime {
        padding-top: 0px;
    }

    .monthCol {
        padding-right: 0;
        margin-left: 40px;
    }

    .monthLab {
        height: 60px;
        padding-top: 7%;
        margin-right: 10%;
        text-align: right;
        font-size: 17px;
    }
</style>